const proxyUrl = "https://cors-anywhere.herokuapp.com/";
const API_ENDPOINT= `${proxyUrl}https://open-air-cinema.herokuapp.com/api/search?region=`

export default API_ENDPOINT;
